import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { supabase } from '../utils/supabase'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/customize',
        component: () => import(/* webpackChunkName: "customize" */ '../views/Customize.vue')
    },
    {
        path: '/job',
        component: () => import(/* webpackChunkName: "job" */ '../views/JobView.vue')
    },
    {
        path: '/setting',
        component: () => import(/* webpackChunkName: "setting" */ '../views/Setting.vue')
    },
    {
        path: '/admin',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminPanel.vue')
    },
    {
        path: '/interview-prep',
        component: () => import(/* webpackChunkName: "interview-prep" */ '../views/InterviewPrep.vue')
    },
    {
        path: '/ai-prep',
        name: 'ai-prep',
        component: () => import(/* webpackChunkName: "ai-prep" */ '../views/InterviewPrep.vue')
    },
    {
        path: '/subscription',
        name: 'subscription',
        component: () => import(/* webpackChunkName: "subscription" */ '../views/SubscriptionPlans.vue')
    },
    {
        path: '/subscription/success',
        name: 'subscription-success',
        component: () => import(/* webpackChunkName: "subscription-success" */ '../views/SubscriptionSuccess.vue')
    },
    {
        path: '/subscription-success',
        name: 'subscription-success-alt',
        component: () => import(/* webpackChunkName: "subscription-success" */ '../views/SubscriptionSuccess.vue')
    },
    {
        path: '/subscription/cancel',
        name: 'subscription-cancel',
        component: () => import(/* webpackChunkName: "subscription-cancel" */ '../views/SubscriptionCancel.vue')
    },
    {
        path: '/subscription-cancelled',
        name: 'subscription-cancelled',
        component: () => import(/* webpackChunkName: "subscription-cancelled" */ '../views/SubscriptionCancelled.vue')
    },
    {
        path: '/checkout/success',
        name: 'checkout-success',
        component: () => import(/* webpackChunkName: "checkout-success" */ '../views/CheckoutSuccess.vue')
    },
    {
        path: '/checkout/cancelled',
        name: 'checkout-cancelled',
        component: () => import(/* webpackChunkName: "checkout-cancelled" */ '../views/CheckoutCancelled.vue')
    },
    {
        path: '/welcome/:sessionId',
        name: 'welcome',
        component: () => import(/* webpackChunkName: "welcome" */ '../views/Welcome.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Login.vue')
    },
    {
        path: '/signup',
        name: 'signup',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Signup.vue')
    },
    {
        path: '/signup-pro',
        name: 'signup-pro',
        component: () => import(/* webpackChunkName: "signup-pro" */ '../views/IntegratedSignup.vue')
    },
    {
        path: '/signup-success',
        name: 'signup-success',
        component: () => import(/* webpackChunkName: "signup-success" */ '../views/SignupSuccess.vue')
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

// Navigation guard to redirect authenticated users away from interview pages to dashboard
router.beforeEach(async (to, from, next) => {
    try {
        // Get current user authentication status
        const { data: { user } } = await supabase.auth.getUser()
        
        // Allow access to welcome page regardless of authentication status
        if (to.path.startsWith('/welcome/')) {
            console.log('🎉 Allowing access to welcome page:', to.path)
            return next()
        }
        
        // Define interview-related pages that should only be available in desktop app
        const interviewPages = ['/', '/customize', '/job', '/ai-prep', '/interview-prep']
        
        // If user is authenticated and trying to access interview pages, redirect to dashboard immediately
        if (user && interviewPages.includes(to.path)) {
            console.log('🌐 Web user redirected from interview page to dashboard:', to.path)
            // Use replace instead of push to avoid the flash and prevent history entry
            return next({ path: '/dashboard', replace: true })
        }
        
        // For root path with authenticated users, go directly to dashboard
        if (user && to.path === '/') {
            console.log('🌐 Authenticated user accessing root, redirecting to dashboard')
            return next({ path: '/dashboard', replace: true })
        }
        
        // Allow access to all other pages
        next()
    } catch (error) {
        console.warn('Navigation guard error:', error)
        // If there's an error getting user status, allow navigation to continue
        next()
    }
})

export default router
